<template>
  <div>
    <Block class="mb60">
      <div class="address-title">{{ $t('present_address') }}</div>
      <md-field>
        <InputValidate
          v-model="countryText"
          v-validate="'required'"
          :title="$t('country')"
          name="birthCountry"
          data-vv-value-path="innerValue"
          :error="errors.first('birthCountry')"
          :readonly="true"
          :show-arrow="true"
          @click.native="showCountrySelector = true"
        />
        <md-selector
          v-model="showCountrySelector"
          :default-value="from.birthCountry"
          :data="countryList"
          max-height="320px"
          :title="$t('country')"
          :ok-text="$t('done')"
          :cancel-text="$t('cancel')"
          large-radius
          @confirm="onSelectorConfirm"
        />

        <inputAddressPicker
          ref="residentialDistrictCode"
          :address.sync="from.residentialDistrictCode"
        />

        <InputValidate
          v-model="from.residentialStreetAddress"
          v-validate="'required'"
          :title="$t('detail_address')"
          name="residentialStreetAddress"
          data-vv-value-path="innerValue"
          data-vv-validate-on="blur"
          :error="errors.first('residentialStreetAddress')"
        />
        <InputValidate
          v-model="from.residentialExtAddress"
          :title="$t('residential_ext_address')"
          name="residentialExtAddress"
          data-vv-value-path="innerValue"
          data-vv-validate-on="blur"
          :error="errors.first('residentialExtAddress')"
        />
        <InputValidate
          v-model="from.residentialPostalCode"
          :title="$t('zip_code_optional')"
          type="digit"
          maxlength="5"
        />
      </md-field>
    </Block>

    <!-- 永久地址 -->
    <Block>
      <div class="address-title">{{ $t('permanent_address') }}</div>

      <md-field>
        <InputValidate
          v-model="from.address"
          v-validate="'required'"
          :title="$t('permanent_address')"
          name="address"
          data-vv-value-path="innerValue"
          data-vv-validate-on="blur"
          :error="errors.first('address')"
        />
        <InputValidate
          v-model="from.postalCode"
          :title="$t('zip_code_optional')"
          type="digit"
          maxlength="5"
        />
      </md-field>
    </Block>
  </div>
</template>

<script>
import Block from '@/components/Block'
import InputValidate from '@/components/InputValidate'
import inputAddressPicker from '@/components/inputAddressPicker'
import { Field, Switch, CellItem, Selector } from 'mand-mobile'

export default {
  name: 'FromDown',

  components: {
    Block,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [CellItem.name]: CellItem,
    [Selector.name]: Selector,
    InputValidate,
    inputAddressPicker
  },

  data () {
    const validateCustom = {
      custom: {
        residentialDistrictCode: {
          required: () => this.$t('required')
        },
        residentialStreetAddress: {
          required: () => this.$t('required')
        },
        workingDistrictCode: {
          required: () => this.$t('required')
        },
        birthCountry: {
          required: () => this.$t('required')
        },
        address: {
          required: () => this.$t('required')
        }
      }
    }
    return {
      validateCustom,
      from: {
        birthCountry: 'ID',
        // 居住地址 区编码
        residentialDistrictCode: '',
        // 居住地址 扩展地址
        residentialExtAddress: '',
        // 居住地址 邮编
        residentialPostalCode: '',
        // 居住地址 街道地址
        residentialStreetAddress: '',
        address: this.$route.query.address
      },
      countryText: 'Indonesia',
      countryList: [
        {
          value: 'ID',
          text: 'Indonesia'
        }
      ],
      showCountrySelector: false
    }
  },
  mounted () {
    this.$validator.localize('zh_CN', this.validateCustom)
  },
  methods: {
    // 选择国籍时
    onSelectorConfirm ({ text, value }) {
      this.countryText = text
      this.from.birthCountry = value
    },
    // 校验获取from数据
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.residentialDistrictCode.validate()
        this.$validator.validate().then((result) => {
          if (result) {
            resolve(this.from)
          } else {
            reject(new Error())
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-title {
  font-size: 28px;
  font-weight: 500;
}
</style>
